import { createContext } from "react";


export const AuthContext = createContext({

    isLoggedIn: false, 
    user: null,
    token: null,
    role: null,
    login: () => {}, 
    logout: () => {} 
});

